import React, { useState } from 'react'
import LibraryDetail from '../ContentManagement/Library/LibraryDetail';

const ContentLibrary = () => {
    const [activeHeader, setActiveHeader] = useState("LiveSession");
    const [create, setCreate] = useState({
        createContent: "",
        chapterdetail: "",
      });
    return (
        <LibraryDetail
            setActiveHeader={setActiveHeader}
            setCreate={setCreate}
        />
    )
}

export default ContentLibrary